import {makeStyles} from '@material-ui/styles';
import {Button, FormControl, Grid, TextField, Typography} from '@material-ui/core';
import {useState} from 'react';
import Link from '../../component/Link/Link';
import {useClient} from '../../app/Ged';
import {Alert, AlertTitle} from '@material-ui/lab';
import {useSelector} from "react-redux";
import {selectSettings} from "../Settings/settingsSlice";

const useStyles = makeStyles(theme => ({
    root: {
        margin: theme.spacing(8, 'auto'),
        padding: theme.spacing(4),
        maxWidth: 800,
        textAlign: 'center',
        backgroundColor: 'white',
        borderRadius: 10,
        boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
    },
    form: {
        margin: theme.spacing(4, 'auto'),
    },
    formControl: {
        margin: theme.spacing(4, 'auto'),
    },
    link: {
        fontSize: '80%',
    }
}));

export default function PasswordResetRequestForm() {
    const classes = useStyles();
    const [orderNumber, setOrderNumber] = useState(null);
    const {request, isLoading, error} = useClient();
    const [requestSent, setRequestSent] = useState(false);
    const settings = useSelector(selectSettings);

    async function handleSubmit(e) {
        e.preventDefault();

        await request({
            method: 'post',
            url: '/api/v2/users/ask_password_reset',
            data: {username: orderNumber},
        });

        setRequestSent(true);

        return false;
    }

    return <div className={classes.root}>

        <h1>Mot de passe oublié ?</h1>

        <form className={classes.form} onSubmit={handleSubmit}>
            {
                !requestSent && <>
                    <Typography>
                        Pour réinitialiser votre mot de passe, veuillez saisir votre identifiant.
                    </Typography>

                    <Grid container justifyContent="center" spacing={2} alignItems="center">
                        <Grid item xs={12} md={5}>
                            <FormControl className={classes.formControl}>
                                <TextField placeholder={"Votre identifiant"} value={orderNumber || ''} label={settings.identifier_name_input_label} onChange={e => setOrderNumber(e.target.value === '' ? null : e.target.value)} />
                            </FormControl>
                        </Grid>
                    </Grid>
                    <Grid container justifyContent="center" spacing={2} alignItems="center">
                        <Grid item xs={12} md={5}>
                            <Button type="submit" variant="contained" color="primary" disabled={orderNumber === null || isLoading} fullWidth>Réinitialiser mon mot de passe</Button>
                        </Grid>
                    </Grid>
                    {
                        error && <Grid container justifyContent="center" spacing={2} alignItems="center">
                            <Grid item xs={12} md={5}>
                                <Alert severity="error"><AlertTitle>{error}</AlertTitle></Alert>
                            </Grid>
                        </Grid>
                    }
                </>
            }
            {
                requestSent && <Grid container justifyContent="center" spacing={2} alignItems="center">
                    <Grid item xs={12} md={12}>
                        <Alert severity="success"><AlertTitle>Un email pour réinitialiser votre mot de passe vous a été envoyé.</AlertTitle></Alert>
                    </Grid>
                </Grid>
            }
        </form>

        <p style={{textAlign: 'center'}}>
            <Link to="/" size="sm">Retour au formulaire de connexion</Link>
        </p>

    </div>;
}
